import React, { useState, useEffect } from 'react'
import { Flex, Box, Button, Input, Text, Image, useToast, AspectRatio } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
//import { products } from './Products';
import { Icon } from '@iconify/react';
import { bk1, bk2 } from '../assets/colors'
import Cookies from 'js-cookie';
export const bk3 = 'linear-gradient(153deg, rgba(152, 152, 152, 0.03) 0%, rgba(152, 152, 152, 0.03) 9%,rgba(197, 197, 197, 0.03) 9%, rgba(197, 197, 197, 0.03) 21%,rgba(106, 106, 106, 0.03) 21%, rgba(106, 106, 106, 0.03) 32%,rgba(222, 222, 222, 0.03) 32%, rgba(222, 222, 222, 0.03) 72%,rgba(16, 16, 16, 0.03) 72%, rgba(16, 16, 16, 0.03) 92%,rgba(181, 181, 181, 0.03) 92%, rgba(181, 181, 181, 0.03) 97%,rgba(130, 130, 130, 0.03) 97%, rgba(130, 130, 130, 0.03) 100%),linear-gradient(39deg, rgba(237, 237, 237, 0.03) 0%, rgba(237, 237, 237, 0.03) 22%,rgba(126, 126, 126, 0.03) 22%, rgba(126, 126, 126, 0.03) 55%,rgba(196, 196, 196, 0.03) 55%, rgba(196, 196, 196, 0.03) 61%,rgba(121, 121, 121, 0.03) 61%, rgba(121, 121, 121, 0.03) 71%,rgba(133, 133, 133, 0.03) 71%, rgba(133, 133, 133, 0.03) 84%,rgba(132, 132, 132, 0.03) 84%, rgba(132, 132, 132, 0.03) 97%,rgba(185, 185, 185, 0.03) 97%, rgba(185, 185, 185, 0.03) 100%),linear-gradient(124deg, rgba(168, 168, 168, 0.03) 0%, rgba(168, 168, 168, 0.03) 7%,rgba(169, 169, 169, 0.03) 7%, rgba(169, 169, 169, 0.03) 19%,rgba(73, 73, 73, 0.03) 19%, rgba(73, 73, 73, 0.03) 50%,rgba(150, 150, 150, 0.03) 50%, rgba(150, 150, 150, 0.03) 67%,rgba(68, 68, 68, 0.03) 67%, rgba(68, 68, 68, 0.03) 81%,rgba(111, 111, 111, 0.03) 81%, rgba(111, 111, 111, 0.03) 91%,rgba(191, 191, 191, 0.03) 91%, rgba(191, 191, 191, 0.03) 100%),linear-gradient(95deg, rgba(147, 147, 147, 0.03) 0%, rgba(147, 147, 147, 0.03) 17%,rgba(79, 79, 79, 0.03) 17%, rgba(79, 79, 79, 0.03) 27%,rgba(28, 28, 28, 0.03) 27%, rgba(28, 28, 28, 0.03) 45%,rgba(27, 27, 27, 0.03) 45%, rgba(27, 27, 27, 0.03) 56%,rgba(228, 228, 228, 0.03) 56%, rgba(228, 228, 228, 0.03) 64%,rgba(38, 38, 38, 0.03) 64%, rgba(38, 38, 38, 0.03) 72%,rgba(42, 42, 42, 0.03) 72%, rgba(42, 42, 42, 0.03) 100%),linear-gradient(346deg, rgba(59, 59, 59, 0.03) 0%, rgba(59, 59, 59, 0.03) 16%,rgba(66, 66, 66, 0.03) 16%, rgba(66, 66, 66, 0.03) 20%,rgba(236, 236, 236, 0.03) 20%, rgba(236, 236, 236, 0.03) 41%,rgba(244, 244, 244, 0.03) 41%, rgba(244, 244, 244, 0.03) 55%,rgba(106, 106, 106, 0.03) 55%, rgba(106, 106, 106, 0.03) 61%,rgba(220, 220, 220, 0.03) 61%, rgba(220, 220, 220, 0.03) 63%,rgba(209, 209, 209, 0.03) 63%, rgba(209, 209, 209, 0.03) 100%),linear-gradient(90deg, rgb(53,31,74),rgb(29,40,80))';
export default function InfoProduct() {
    const { id } = useParams();
    const navigate = useNavigate();
    const toast = useToast();
    const [product, setProduct] = useState(null);
    const { products } = useSelector((state) => state.product)
    const { isLogged } = useSelector((state) => state.auth);
    const access_token = Cookies.get('access_token');
    const [showVideo, setShowVideo] = useState(false);
    const [IDS, setIDS] = useState([]);
    useEffect(() => {
        if (product === null || product === undefined) {
            if (products !== null) {
                setProduct(products.find((item) => item.id.toString() === id))
            }
        }
    }, [product, products, id])
    const handleCart = () => {
        if (isLogged) {
            const data = {
                id: id,
            }
            try {
                fetch('https://api.zyll.shop/add-cart/', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access_token}`
                    },
                    body: JSON.stringify(data)
                })
                    .then((response) => response.ok && navigate('/cart'))


            } catch (error) {
                toast({
                    title: 'Error',
                    description: error.message,
                    status: 'error',
                    duration: 5000,
                    isClosable: true,
                    position: 'top',
                })
            }
        }
    }
    const handleCheckout = () => {

        IDS.push(product.id);
        const total = product.price
        navigate('/checkout', { state: { IDS, total } });
    }
    const handleVideo = () => {
        setShowVideo(!showVideo);
    }
    useEffect(() => {
        fetch('https://api.zyll.shop/visit/info-product/')
    }, [])

    return (
        product !== null ? (
            <Flex
                width={'88%'}
                height={'600px'}
                mt={4}
                flexDir={{ base: 'column', md: 'row' }}
                justifyContent={'space-between'}
            >
                <Flex
                    flexDir={'column'}
                    width={{ base: '100%', md: '30%' }}

                >
                    <Flex
                        height={'310px'}
                        bgGradient={bk3}
                        borderRadius={8}
                        alignItems={'center'}
                        width={'100%'}
                        flexDir={'column'}
                        pb={3}

                    >
                        {product !== null ? (
                            <>
                                <Text
                                    fontSize={20}
                                    color={'#fff'}
                                    fontWeight={'bold'}
                                    m={1}
                                >
                                    {product.name}
                                </Text>
                                <Image
                                    src={product.image_link}
                                    width={300}
                                    height={200}
                                    m={2}
                                    borderRadius={2}
                                />

                                <Flex alignItems={'center'} justifyContent={'center'} width={'80%'}>
                                    <Button
                                        colorScheme='gray'
                                        color={'white'}
                                        bgGradient={bk1}
                                        borderRightRadius={0}
                                        onClick={handleCheckout}
                                        width={'100%'}
                                        sx={{
                                            transform: 'scale(0.99)',
                                            transition: 'box-shadow 0.5s, transform 0.5s',
                                            '&:hover': {
                                                transform: 'scale(1)',
                                                backgroundColor: '#d8d8d8',
                                                boxShadow: '5px 20px 30px rgba(0, 0, 0, 0.3)',
                                                color: '#1d2850',
                                            },
                                        }}

                                    >Buy it for {product.price}$</Button>
                                    <Flex
                                        justifyContent={'center'}
                                        borderLeftWidth={0.1}
                                        borderLeftColor={'#d8d8d8'}
                                        width={'50px'}
                                        height={'42px'}
                                        alignItems={'center'}
                                        bgColor={'#1d2850'}
                                        color={'silver'}
                                        as={Button}
                                        padding={3}
                                        borderLeftRadius={0}
                                        sx={{
                                            transform: 'scale(0.95)',
                                            transition: 'box-shadow 0.5s, transform 0.5s',
                                            '&:hover': {
                                                transform: 'scale(1)',
                                                backgroundColor: '#d8d8d8',
                                                boxShadow: '5px 20px 30px rgba(0, 0, 0, 0.3)',
                                                borderEndEndRadius: 8,
                                                color: '#1d2850',
                                            },
                                        }}
                                        onClick={handleCart}
                                    >
                                        <Icon icon={'material-symbols:add-shopping-cart'} width={30} height={30} />
                                    </Flex>

                                </Flex>
                            </>
                        ) : ''}
                    </Flex>
                    <Flex
                        height={{ base: 'fit', md: '310px' }}
                        bgGradient={bk3}
                        borderRadius={8}
                        alignItems={'center'}
                        width={'100%'}
                        flexDir={'column'}
                        color={'#fff'}
                        mt={5}
                        p={3}
                    >
                        {product !== null ? product.type === "Tools" && (

                            <>
                                <Text marginBottom="20px" fontFamily='Inika-Bold Helvetica' fontSize='26px'>Activation</Text>

                                <Text marginBottom="20px" fontFamily='Inika-Bold Helvetica' fontSize='20px'>One IP and can be exchanged</Text>
                                <Text marginBottom="20px" fontFamily='Inika-Bold Helvetica' fontSize='20px'>Program Duration : one month and can be forever without updating</Text>
                            </>

                        ) : (
                            <>

                            </>

                        )}
                    </Flex>

                </Flex>

                <Flex
                    height={'fit'}
                    bgColor={'#1B1639'}
                    borderRadius={8}
                    alignItems={'center'}
                    width={{ base: '100%', md: '68%' }}
                    flexDir={'column'}
                    mt={{ base: 6, md: 0 }}
                    bgGradient={bk3}
                >
                    <Flex
                        p={5}
                        fontFamily='Inika'
                        textAlign="left"
                        color='silver'
                        overflowY='auto'
                        width={'98%'}
                        fontSize={'large'}
                    >

                        {product !== null ? (
                            <Flex
                                dangerouslySetInnerHTML={{ __html: product.description }}
                                flexDir={'column'}
                            />

                        ) : ''}


                    </Flex>
                    {product.video !== "" && <>
                        <Button height={'50px'} mt='5px' colorScheme='red' width='100%' variant='outline' onClick={handleVideo}>فيديو شرح</Button>
                        <Flex justifyContent='center' width={'100%'} overflowY={'scroll'} mt={2} mb={2}>
                            {showVideo && (
                                <AspectRatio maxW='560px' ratio={1} alignSelf='center' mt='5px' width='100%'>
                                    <iframe
                                        title='naruto'
                                        src={product.video}
                                        allowFullScreen
                                    />
                                </AspectRatio>
                            )}
                        </Flex>
                    </>}
                </Flex>

            </Flex>
        ) : (
            <Flex height={'70vh'} justifyContent={'center'} alignItems={'center'} color={'#1B1639'} sx={{
                transform: 'scale(0.95)',
                transition: 'box-shadow 0.5s, transform 0.5s',

            }}>
                <Icon icon={'svg-spinners:blocks-shuffle-3'} width={200} height={200} />
            </Flex>
        )
    )
}
